/* eslint-disable no-underscore-dangle */
import { useEffect } from "react";
import { Row, Col } from "react-flexbox-grid";
import { Link } from "react-router-dom";
import { PageWrapper } from "components";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";

import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import LockIcon from "@material-ui/icons/Lock";
import AssignmentIcon from "@material-ui/icons/Assignment";
import SmsFailedIcon from "@material-ui/icons/SmsFailed";

import { useGlobalContext } from "context/GlobalContext";
import { withLoader } from "HOC";

const data = [
  { icon: <AccountCircleIcon />, label: "Mi perfil", to: "/cuenta" },
  { icon: <LockIcon />, label: "Cambiar clave", to: "/recuperar-acceso" },
  {
    icon: <AssignmentIcon />,
    label: "Términos y condiciones",
    type: "legal",
  },
  {
    icon: <SmsFailedIcon />,
    label: "Quejas, sugerencias y felicitaciones",
    to: "/buzon",
    divider: true,
  },
  {
    icon: <ExitToAppIcon />,
    label: "Cerrar sesión",
    type: "logout",
  },
];

const Setting = ({ setLoading }) => {
  const gContext = useGlobalContext();

  useEffect(() => {
    setLoading(false);
  }, []);

  const handleTypeAction = (type) => {
    if (type) {
      switch (type) {
        case "logout":
          gContext.toggleModal({
            title: "Cerrar sesión",
            description: "¿Esta seguro(a) que desea cerrar sesión?",
            okText: "Si, cerrar sesión",
            cancelText: "Cancelar",
            onOk: () => {
              gContext.handleSetUser(null);
              gContext.toggleModal(null);
            },
            onCancel: () => {
              gContext.toggleModal(null);
            },
          });
          break;
        default:
          gContext.toggleLegalModal();
          break;
      }
    }
  };

  return (
    <PageWrapper
      isBack={false}
      header={
        <Row center="xs">
          <Col md={12}>
            <h1>Configuración</h1>
          </Col>
        </Row>
      }
    >
      <Col md={12} className="bottom" role="presentation">
        <List>
          {data.map(({ to, label, icon, divider, type }) => (
            <ListItem
              key={label}
              button
              component={to ? Link : "a"}
              to={to}
              href={null}
              divider={divider}
              onClick={() => handleTypeAction(type)}
            >
              <ListItemIcon>{icon}</ListItemIcon>
              <ListItemText primary={label} />
            </ListItem>
          ))}
        </List>
      </Col>
    </PageWrapper>
  );
};

export default withLoader(Setting, "Cargando ajustes");
